export default "__VITE_ASSET__HlM8I8Oi__"